import { TprmSchema } from '@evidentid/tprm-portal-lib/models/common/TprmSchema.model';
import { TprmSchemaDisplayFormat } from '@evidentid/tprm-portal-lib/models/common/TprmSchemaDisplayFormat.model';
import { CustomProperty } from '@evidentid/tprm-portal-lib/models/dashboard';

export function isCustomPropertyAddress(insuredField: CustomProperty): boolean {
    return (insuredField.schema as TprmSchema).displayFormat === TprmSchemaDisplayFormat.address;
}
